import { Text } from '../Text';
import { escapeRegExp } from './Select.helpers';
import { StyledHighlightText } from './Select.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const HighlightText = ({
  text,
  highlight,
  isSupportText,
  optionTextColor
}) => {
  const typography = isSupportText ? 'detail-100' : 'body-100';
  if (!highlight.trim()) {
    return /*#__PURE__*/_jsx(Text, {
      truncate: true,
      typography: typography,
      color: optionTextColor,
      children: text
    });
  }
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
  const parts = text.split(regex);
  return /*#__PURE__*/_jsx(Text, {
    truncate: true,
    typography: typography,
    color: optionTextColor,
    children: parts.map((part, index) => regex.test(part) ? /*#__PURE__*/_jsx(StyledHighlightText, {
      children: part
    }, `${index}-${part}`) : part)
  });
};